import { BaseWebComponentRepository } from '../../framework/BaseWebComponentRepository';
import { PhasrApplyActionPanelDataProviderFactory } from '../factory/PhasrApplyActionPanelDataProviderFactory';
import { PhasrApplyActionPanelBaseDataProvider } from '../dataProvider/PhasrApplyActionPanelBaseDataProvider';

export class PhasrApplyActionPanelRepository extends BaseWebComponentRepository {
  public dataProviderFactory: PhasrApplyActionPanelDataProviderFactory;
  public dataProvider: PhasrApplyActionPanelBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new PhasrApplyActionPanelDataProviderFactory(),
    });
  }
}
